import { Smartphone, Share, PlusSquare, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useInstallPrompt, isStandalone, isIOS } from "@/lib/pwa";

export const InstallButton = ({ className = "", onDone }) => {
  const { canInstall, install } = useInstallPrompt();
  if (!canInstall || isStandalone()) return null;
  return (
    <Button data-testid="install-app-btn" size="sm" className={className} onClick={async () => { if (await install()) toast.success("Radar installé sur cet appareil"); onDone?.(); }}>
      <Smartphone className="h-3.5 w-3.5 mr-1.5" />Installer l'application
    </Button>
  );
};

export const InstallPanel = () => {
  const { canInstall } = useInstallPrompt();
  const standalone = isStandalone();
  return (
    <div className="panel p-4 space-y-2" data-testid="install-panel">
      <div className="flex items-center gap-2 font-display text-sm font-bold"><Smartphone className="h-4 w-4" />Installer sur l'écran d'accueil</div>
      {standalone ? (
        <p className="text-xs text-emerald-700 dark:text-emerald-400 flex items-center gap-1.5"><CheckCircle2 className="h-3.5 w-3.5" />Le radar est déjà ouvert comme application installée.</p>
      ) : canInstall ? (
        <>
          <p className="text-xs text-slate-500">Ouvrez le radar comme une application, en plein écran, depuis l'icône de votre téléphone ou de votre ordinateur.</p>
          <InstallButton />
        </>
      ) : isIOS() ? (
        <ol className="text-xs text-slate-600 dark:text-slate-300 space-y-1.5" data-testid="install-ios-steps">
          <li className="flex items-center gap-1.5">1. Dans Safari, touchez <Share className="h-3.5 w-3.5 inline" /> <b>Partager</b></li>
          <li className="flex items-center gap-1.5">2. Choisissez <PlusSquare className="h-3.5 w-3.5 inline" /> <b>Sur l'écran d'accueil</b></li>
          <li>3. Validez avec <b>Ajouter</b> : l'icône « Radar » apparaît sur votre écran d'accueil.</li>
        </ol>
      ) : (
        <p className="text-xs text-slate-500" data-testid="install-generic-steps">Sur Android (Chrome) : menu ⋮ → <b>Installer l'application</b> ou <b>Ajouter à l'écran d'accueil</b>. Sur ordinateur (Chrome / Edge) : icône d'installation à droite de la barre d'adresse.</p>
      )}
    </div>
  );
};
